function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6297e91b\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader?{\"globalVars\":{\"brand-color\":\"#E02727\",\"color-434343\":\"#434343\",\"color-666\":\"#666666\",\"color-999\":\"#999999\",\"color-e5e5e5\":\"#e5e5e5\",\"color-ebebeb\":\"#ebebeb\",\"color-f1f1f1\":\"#f1f1f1\",\"color-f5f5f5\":\"#f5f5f5\"},\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./UdcSlider.vue")
  require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6297e91b\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader?{\"globalVars\":{\"brand-color\":\"#E02727\",\"color-434343\":\"#434343\",\"color-666\":\"#666666\",\"color-999\":\"#999999\",\"color-e5e5e5\":\"#e5e5e5\",\"color-ebebeb\":\"#ebebeb\",\"color-f1f1f1\":\"#f1f1f1\",\"color-f5f5f5\":\"#f5f5f5\"},\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./UdcSlider.vue")
}
var normalizeComponent = require("!../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UdcSlider.vue"
import __vue_script__ from "!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UdcSlider.vue"
/* template */
import __vue_template__ from "!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6297e91b\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UdcSlider.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6297e91b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./module/forgetPassword/src/components/UdcSlider.vue
// module id = Esyx
// module chunks = 1